module.exports = __webpack_public_path__ + "static/media/hero-vbn-mobile.5c587515.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/images/Landing/hero-vbn-mobile.jpg
// module id = 206
// module chunks = 51